import { objectMap } from 'srcReact/helpers/utils'
import { moderationReportConstants as mrc } from 'srcReact/ModerationReportPage'

const initialState = {
  loading: false,
  loaded: false,
  reload: false,
  error: {
    message: ''
  },
  success: false,
  flag_reasons: [],
  moderation_rights: [],
  moderation_stats: {
    tab: {
      workplace_activity: {
        total: 0,
        groups: 0,
        mixrs: 0
      },
      awaiting_review: {
        total: 0
      },
      history: {
        total: 0
      }
    }
  },
  moderation_data: {
    posts: null,
    pagination: {
      total: 0,
      next_offset: 0,
      remaining: 0
    },
    item_needs_immediate_rewiew: {
      count: 0
    }
  },
  suspend: {
    loading: false,
    error: '',
    data: null
  },
  reinstate: {
    loading: false,
    error: '',
    data: null
  }
}

export function moderationReport(state = initialState, action) {
  switch (action.type) {
    case mrc.GET_MODERATION_FLAG_REASONS_REQUEST:
    case mrc.GET_MODERATION_FLAG_REASONS_FAILURE:
      return {
        ...state
      }
    case mrc.GET_MODERATION_FLAG_REASONS_SUCCESS:
      return {
        ...state,
        flag_reasons: action.data.flag_reasons
      }

    case mrc.GET_MODERATION_INFO_REQUEST:
      return {
        ...state,
        loading: true
      }
    case mrc.GET_MODERATION_INFO_SUCCESS:
      return {
        ...state,
        ...action.data,
        moderation_rights: action.data.moderation_rights,
        moderation_stats: {
          ...state.moderation_stats,
          tab: {
            ...state.moderation_stats.tab,
            ...action.data.moderation_stats.tab
          }
        },
        moderation_data: {
          ...state.moderation_data,
          ...action.data.moderation_data
        },
        loading: false,
        loaded: true
      }
    case mrc.GET_MODERATION_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          ...state.error,
          message: action.error
        }
      }

    case mrc.ADD_FLAG_REQUEST:
      return {
        ...state,
        loading: true
      }
    case mrc.ADD_FLAG_SUCCESS:
    case mrc.ADD_FLAG_FAILURE:
      return {
        ...state,
        loading: false
      }

    case mrc.ACTION_FLAG_REQUEST:
    case mrc.ACTION_FLAG_FAILURE:
      return {
        ...state
      }
    case mrc.ACTION_FLAG_SUCCESS:
      return {
        ...state,
        reload: !state.reload
      }
    case mrc.SUSPEND_REQUEST:
      {
        return {
          ...state,
          suspend: {
            ...state.suspend,
            loading: true,
            data: null,
            error: ''
          }
        }
      }
    case mrc.SUSPEND_SUCCESS:
      {
        const { response, object_id } = action
        const updatedPosts = state.moderation_data.posts?.filter(x => x.object_id !== object_id)

        return {
          ...state,
          moderation_data: {
            ...state.moderation_data,
            posts: updatedPosts
          },
          suspend: {
            ...state.suspend,
            loading: false,
            data: response && response.action,
            error: ''
          }
        }
      }
    case mrc.SUSPEND_FAILURE:
      {
        return {
          ...state,
          suspend: {
            ...state.suspend,
            loading: false,
            data: null,
            error: action.error
          },
        }
      }
    case mrc.VALIDATE_REQUEST:
      {
        return {
          ...state,
          loading: true,
          validateSuccess: false,
          error: ''
        }
      }

    case mrc.VALIDATE_SUCCESS:
      {
        const { response, object_id } = action
        const updatedPosts = state.moderation_data.posts?.filter(x => x.object_id !== object_id)

        return {
          ...state,
          moderation_data: {
            ...state.moderation_data,
            posts: updatedPosts
          },
          loading: false,
          validateSuccess: true,
          error: ''
        }
      }
    case mrc.VALIDATE_FAILURE:
      {
        return {
          ...state,
          loading: false,
          validateSuccess: false,
          error: action.error
        }
      }
    case mrc.REINSTATE_REQUEST: {
      return {
        ...state,
        reinstate: {
          ...state.reinstate,
          loading: true,
          error: '',
          data: null
        }

      }
    }
    case mrc.REINSTATE_SUCCESS: {
      return {
        ...state,
        reinstate: {
          ...state.reinstate,
          loading: false,
          error: '',
          data: action.response
        }
      }
    }
    case mrc.REINSTATE_FAILURE: {
      return {
        ...state,
        reinstate: {
          ...state.reinstate,
          loading: false,
          error: action.error,
          data: null
        }

      }
    }
    case mrc.CLEAR_SUSPEND_DATA: {
      return {
        ...state,
        suspend: {
          ...state.suspend,
          loading: false,
          data: null,
          error: ''

        }
      }
    }
    default:
      return state
  }
}
